import React, { useState } from "react";

import { Card, Grid, IconButton, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

import CardBody from "components/Card/CardBody";

import { ClientSecret } from "views/MyApps/ClientSecret";
import { DeleteConfirmModal } from "views/MyApps/DeleteConfirmModal";

const applicationTypes = {
  "customer-dev": "developed for one or more specific SOS customers",
  "3rd-party-dev": "for license to any SOS customer",
};

export function App(props) {
  const [secretShown, setSecretShown] = useState(false);
  const [confirmActive, setConfirmActive] = useState(false);

  function hideSecret() {
    setSecretShown(false);
  }
  function showSecret() {
    setSecretShown(true);
  }

  return (
    <Card>
      <CardBody>
        <Grid container>
          <Grid item xs={12} sm={12} md={12}>
            <Typography variant="h4" component="h2" paragraph>
              {props.app.name}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={3}>
            <Typography variant="h5" component="h3">
              Client ID
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={9}>
            <Typography variant="body1" component="p">
              {props.app.client_id}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={3}>
            <Typography variant="h5" component="h3">
              Client Secret
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={8}>
            <Typography variant="body1" component="p">
              <ClientSecret
                visible={secretShown}
                clientSecret={props.app.client_secret}
                showSecret={showSecret}
                hideSecret={hideSecret}
              />
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={3}>
            <Typography variant="h5" component="h3">
              Application Type
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={8}>
            <Typography variant="body2" component="p">
              {applicationTypes[props.app.application_type]}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={1}>
            <IconButton onClick={() => setConfirmActive(true)} size="large">
              <DeleteIcon style={{ fontSize: "1.0rem" }} />
            </IconButton>
          </Grid>
        </Grid>
      </CardBody>
      <DeleteConfirmModal
        show={confirmActive}
        onClose={() => setConfirmActive(false)}
        appId={props.app.id}
        appName={props.app.name}
        onConfirm={props.handleDeletion}
      >
        Do you really want to delete this application?
      </DeleteConfirmModal>
    </Card>
  );
}
